// angular
//   .module('HeroPRO')
//   .factory('Timestamp', TimestampFactory);

export default function TimestampFactory() {
    const timestamps = {
    };

    return {
        setTimestamp(name) {
            timestamps[name] = new Date().getTime();
        },

        getTimestamp(name) {
            return timestamps[name];
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/common/angular/globalFactories/timestampFactory.js